const config = {
    'App-Version': 'tripla-API/1.0',
    'Tripla-Locale': 'ja',
    'Client-Session': '',
}

export default config;